import { TFunction } from "i18next";
import {
    UserResetPasswordFirstStep,
    UserResetPasswordSecondStep,
    UserResetPasswordThirdStep,
} from "../../domain/models/dto/UserDTO";
import { Fields } from "../../types/SchemaFactory";
import { schemaFactory } from "../SchemaFactory";

export const userResetPasswordFirstStepFields: Fields<UserResetPasswordFirstStep> =
    {
        email: {
            min: 1,
            max: 128,
            required: true,
            placeholderKey: "resetPassword.emailField",
            type: "email",
            initial: "",
        },
    };

export const userResetPasswordSecondStepFields: Fields<UserResetPasswordSecondStep> =
    {
        recoveryCode: {
            min: 6,
            max: 6,
            required: true,
            placeholderKey: "resetPassword.confirmationCodeField",
            type: "text",
            initial: "",
        },
    };

export const userResetPasswordThirdStepFields: Fields<UserResetPasswordThirdStep> =
    {
        password: {
            min: 8,
            max: 128,
            required: {
                value: true,
                key: "registration.passwordRequired",
            },
            placeholderKey: "resetPassword.newPasswordField",
            type: "password",
            initial: "",
        },
        confirmPassword: {
            min: 0,
            max: 128,
            required: {
                value: true,
                key: "registration.confirmPasswordRequired",
            },
            placeholderKey: "resetPassword.confirmNewPasswordField",
            type: "text",
            initial: "",
        },
    };

export const userResetPasswordFirstStepSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, userResetPasswordFirstStepFields);
};

export const userResetPasswordSecondStepSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, userResetPasswordSecondStepFields);
};

export const userResetPasswordThirdStepSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, userResetPasswordThirdStepFields);
};
